import { FC } from 'react';
import styles from './Decorator.module.scss';

interface DecoratorProps {
  className?: string;
}

export const Decorator: FC<DecoratorProps> = ({ className = '' }) => {
  return <div className={`${styles.decorator_body} ${className}`}></div>;
};
